/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import { webApi } from '../../lib/WebApi'

export const SET_ONLINE = 'SET_ONLINE'
export function setOnline(online) {
    return {
        type: SET_ONLINE,
        online: online
    }
}


export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export function setLoggedIn(loggedIn) {
    return {
        type: SET_LOGGED_IN,
        loggedIn: loggedIn
    }
}

export const SET_TEAM = 'SET_TEAM'
export function setTeam(team) {
    return {
        type: SET_TEAM,
        team: team
    }
}

export const SET_GAME = 'SET_GAME'
export function setGame(game) {
    return {
        type: 'COMMON_SET',
        key: 'upload',
        value: {
            game
        }
    }
}

export const SET_GAME_PROPERTY = 'SET_GAME_PROPERTY'
export function setGameProperty(key, val) {
    return {
        type: SET_GAME_PROPERTY,
        key: key,
        val: val
    }
}

export const SET_PROPERTIES = 'SET_PROPERTIES'
export function setProperties(stuff) {
    return {
        type: 'COMMON_SET',
        key: 'upload',
        value: stuff
    }
}

export function loadGame(gameId) {
    return dispatch => {
        webApi._get(`/webapp/games/${gameId}`, { sport_type: 'any' })
            .then(game => {
                dispatch(setProperties({ gameLoaded: true, game: game }))
            })
            .catch(err => console.error(err))
    }
}

export function createGame(cameraType) {
    return dispatch => {
        dispatch(setProperties({
            creatingGame: true,
            createGameError: null
        }))
        webApi.createGame()
            .then(game => {
                game.camera_type = 'not-set'
                dispatch(setProperties({
                    creatingGame: false,
                    createGameError: null,
                    game: game
                }))
                return game
            })
            .then(game => {
                game.camera_type = cameraType
                return webApi.updateGame(game)
                    .then(success => {
                        return game
                    })
            })
            .then(game => {
                dispatch(setProperties({
                    game: Object.assign({}, game)
                }))
            })
            .catch(err => {
                dispatch(setProperties({
                    creatingGame: false,
                    createGameError: err,
                }))
            })
    }
}

export function loadTournamentGames(tournamentId) {
    return dispatch => {
        webApi._get(`/webapp/tournaments/${tournamentId}/games`)
            .then(games => {

                var allGames = []

                while (games.length > 0) {
                    var hg = games[0]
                    var ag = null
                    var agi = -1

                    if (hg.linked_game_id && hg.linked_game_id.length > 0) {
                        var lsg = parseInt(hg.linked_game_id, 10)
                        for (var ai in games) {
                            var g = parseInt(games[ai].game_id, 10)
                            if (g === lsg) {
                                ag = games[ai]
                                agi = ai
                                break
                            }
                        }
                    }

                    var pair = { home_game: fixupGame(hg), away_game: null }
                    if (ag) {
                        games.splice(agi, 1)
                        pair.away_game = fixupGame(ag)
                    }
                    games.splice(0, 1)
                    allGames.push(pair)

                }
                dispatch(setProperties({tournamentGames: allGames}))
            })
            .catch(err => console.log('Upload.actions.loadTournamentGames ERROR', tournamentId, err))
    }
}

function fixupGame(game) {
    var now = new Date()
    var hh = (now.getTimezoneOffset() / 60) + 6

    var fg = Object.assign({}, game)

    fg.home_team.jersey_color = ensureDefault(fg.home_team.jersey_color, '')
    fg.home_team.score = ensureDefault(fg.home_team.score, 0)
    if (fg.away_team) {
        fg.away_team.jersey_color = ensureDefault(fg.away_team.jersey_color, '')
        fg.away_team.score = ensureDefault(fg.away_team.score, 0)
    }

    var start = ensureDefault(fg.approx_start_time, `${hh}:30`)
    var date = ensureDefault(fg.date, '2013-10-29')
    fg.date = localeDate(date, start)
    fg.approx_start_time = localeTime(date, start)

    return fg
}

export function loadTournamentGame(gameId) {
    return dispatch => {
        console.log('loadTournamentGame', 'starting')
        webApi._get(`/webapp/games/${gameId}`, { sport_type: 'any' })
            .then(game => {
                var homeGame = fixupGame(game)
                return homeGame
            })
            .then(homeGame => {
                if (homeGame.linked_game_id && homeGame.linked_game_id.length > 0) {
                    return new Promise((resolve, reject) => {
                        webApi._get(`/webapp/games/${homeGame.linked_game_id}`, { sport_type: 'any' })
                            .then(game => {
                                var awayGame = fixupGame(game)
                                resolve({ home_game: homeGame, away_game: awayGame })
                            })
                            .catch(err => {
                                console.log('Error loading away game', err)
                                resolve({ home_game: homeGame })
                            })
                    })
                } else {
                    return({ home_game: homeGame })
                }
            })
            .then(pair => {
                dispatch(setProperties({game: pair}))
            })
            .catch(err => console.log('Upload.actions.loadTournamentGame ERROR', gameId, err))
    }
}

export function tournamentGenerateGameInfo(teamId, startTime, halfLength, gameFolder) {
    return webApi.checkCameraSync(teamId, dateFromString(startTime), halfLength, gameFolder)
}

export function tournamentGenerateCoachNotes(teamId, startTime, halfLength, gameFolder) {
    return webApi.checkCoachNotes(teamId, dateFromString(startTime), halfLength, gameFolder)
}

function ensureDefault(value, defaultValue) {
    return value ? value : defaultValue
}

function localeDate(gameDate, gameTime) {
    var dateParts = gameDate.split('-')
    var timeParts = gameTime.split(':')

    // Sanitize Date
    var y = 2013
    var m = 9
    var d = 29
    if (dateParts.length > 0) {
        y = parseInt(dateParts[0], 10)
    }
    if (dateParts.length > 1) {
        m = parseInt(dateParts[1], 10) - 1
    }
    if (dateParts.length > 2) {
        d = parseInt(dateParts[2], 10)
    }

    // Sanitize Time
    var hh = 0
    var mm = 30
    var ss = 0
    if (timeParts.length > 0) {
        hh = parseInt(timeParts[0], 10)
    }
    if (timeParts.length > 1) {
        mm = parseInt(timeParts[1], 10)
    }
    if (timeParts.length > 2) {
        ss = parseInt(timeParts[2], 10)
    }

    var date = new Date(Date.UTC(y, m, d, hh, mm, ss))
    y = date.getFullYear()
    m = date.getMonth() + 1
    if (m < 10) {
        m = '0' + m
    }
    d = date.getDate()
    if (d < 10) {
        d = '0' + d
    }

    return `${y}-${m}-${d}`
}

function localeTime(gameDate, gameTime) {
    var dateParts = gameDate.split('-')
    var timeParts = gameTime.split(':')

    // Sanitize Date
    var y = 2018
    var m = 0
    var d = 16
    if (dateParts.length > 0) {
        y = parseInt(dateParts[0], 10)
    }
    if (dateParts.length > 1) {
        m = parseInt(dateParts[1], 10) - 1
    }
    if (dateParts.length > 2) {
        d = parseInt(dateParts[2], 10)
    }

    // Sanitize Time
    var hh = 0
    var mm = 0
    var ss = 0
    if (timeParts.length > 0) {
        hh = parseInt(timeParts[0], 10)
    }
    if (timeParts.length > 1) {
        mm = parseInt(timeParts[1], 10)
    }
    if (timeParts.length > 2) {
        ss = parseInt(timeParts[2], 10)
    }

    // create locale date for current locale
    // console.log("localeTime params", y, m, d, hh, mm, ss)
    var date = new Date(Date.UTC(y, m, d, hh, mm, ss))
    let h = date.getHours()
    if (h < 10) {
        h = '0' + h
    }
    m = date.getMinutes()
    if (m < 10) {
        m = '0' + m
    }
    return `${h}:${m}:00`
}

function dateFromString(val, mo = 1) {
    var str = val ? val : '1970-01-01 00:00:00'
    var parts = str.split(' ')
    var date = new Date(0)
    if (parts.length === 2) {
        var dateParts = parts[0].split('-')
        var timeParts = parts[1].split(':')
        if (dateParts.length === 3 && timeParts.length >= 2) {
            var y = parseInt(dateParts[0], 10)
            var m = parseInt(dateParts[1], 10) - mo
            var d = parseInt(dateParts[2], 10)
            var hh = parseInt(timeParts[0], 10)
            var mm = parseInt(timeParts[1], 10)
            date = new Date(y, m, d, hh, mm)
        }
    }
    // console.log("dateFromString", val, mo, date)
    return date
}

export function loadTeamSuggestions(term, cb) {
    if (term.length <= 2) {
        cb([])
        return
    }

    webApi.autoCompleteTeam(term)
        .then((teams) => {
            cb(teams)
        })
        .catch((err) => {
            console.log(err)
            cb([])
        }) 
}


